
import { atom } from "recoil";
import { initError, Quote, OpenOrder, ShippedOrder, initQuote, UserName, User, initUser } from "../types.d";


export const errorState = atom({
	key: "errorState",
	default: initError(),
});


export const userState = atom({
	key: "userState",
	default: (() => {
		try {
			const storedUser = sessionStorage.getItem('user');
			if (storedUser && storedUser !== 'null' && storedUser !== 'undefined') {
				const parsedUser = JSON.parse(storedUser);
				// Ensure parsedUser is not null and has required properties
				if (parsedUser && typeof parsedUser === 'object' && parsedUser.hasOwnProperty('username')) {
					return parsedUser;
				}
			}
		} catch (error) {
			console.warn('Failed to parse user from localStorage:', error);
		}
		// Fallback to initial user if localStorage is empty or invalid
		return initUser();
	})()
});


export const quotesState = atom<Quote[]>({
	key: "quotesState",
	default: [],
});


export const openOrdersState = atom<OpenOrder[]>({
	key: "openOrdersState",
	default: [],
});


export const shippedOrdersState = atom<ShippedOrder[]>({
	key: "shippedOrdersState",
	default: [],
});


export const currentQuoteState = atom<Quote>({
	key: "currentQuoteState",
	default: initQuote(),
});


export const openRespState = atom<boolean>({
	key: "openRespState",
	default: false,
});


export const shippedRespState = atom<boolean>({
	key: "shippedRespState",
	default: false,
});


export const quoteRespState = atom<boolean>({
	key: "quoteRespState",
	default: false,
});


export const userListState = atom<UserName[]>({
	key: "userListState",
	default: [],
}); 


export const updateUserState = atom<User>({
	key: "updateUserState",
	default: initUser(),
});


export const updateSuccessState = atom<boolean>({
	key: "updateSuccessState",
	default: false,
});


